import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.1/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@4.1.6_patch_hash=qozg4yvpj3ozhoqofl2lexxsgu_webpack@4.47.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ChevronDown.icon",
  "use": "ChevronDown.icon-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"ChevronDown.icon\"><path stroke=\"currentColor\" stroke-width=\"2\" d=\"M2 4l4 4 4-4\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol